import React, { useState, useEffect, createContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export const UserContext = createContext();
export const UserContextProvider = (props) => {
 const navigate = useNavigate();
 const [toggleShowNav, setToggleShowNav] = useState(false);

 const toggleNavDisplay = () => {
  setToggleShowNav((e) => !e);
 };

 const [user, setUser] = useState(false);
 const [token, setToken] = useState(null);
 const [admin, setAdmin] = useState(false);
 const [loading, setLoading] = useState(true);
 const [courses, setCourses] = useState();

 useEffect(() => {
  checkAuth();
 }, [token]);

 const logOut = async () => {
  try {
   const response = await axios.get(
    // process.env.REACT_APP_BASEURL + "/api/v1/logout",
    "http://localhost:5000/api/v1/logout",
    {
     withCredentials: true,
    }
   );
   navigate("/");
   setUser(false);
  } catch (error) {
   console.log(error);
  }
 };

 const checkAuth = async () => {
  try {
   const response = await axios.get(
    // process.env.REACT_APP_BASEURL + "/api/v1/auth",
    "http://localhost:5000/api/v1/auth",
    { withCredentials: true }
   );

   setUser(response.data.user);
   setLoading(false);
  } catch (error) {
   setUser(false);
   setLoading(false);
   console.log(error.message);
  }
 };

 const getCourses = async () => {
  setLoading(true);
  try {
   const { data } = await axios.get(
    process.env.REACT_APP_BASEURL + "/api/v1/courses",
    { withCredentials: true }
   );

   setCourses(data.data);

   setLoading(false);
  } catch (error) {
   setUser(false);
   setLoading(false);
   console.log(error.message);
  }
 };

 const createCourse = async ({ title, description }) => {
  try {
   const response = await axios.post(
    process.env.REACT_APP_BASEURL + "/api/v1/admin/create-course",
    { title, description },
    {
     withCredentials: true,
    }
   );
   setCourses([response.data.data, ...courses]);
   setLoading(false);

   return { message: "You have succesfully created a course" };
  } catch (error) {
   setLoading(false);
   return {
    message: "An error occured during the process, please try again later",
   };
  }
 };

 const updateCourse = async ({ id, title, description }) => {
  try {
   const response = await axios.put(
    process.env.REACT_APP_BASEURL + "/api/v1/admin/update-course",
    { id, title, description },
    {
     withCredentials: true,
    }
   );
   setLoading(false);
   console.log(response.data.data);
   setCourses(
    courses.map((course) => {
     if (course._id === id) {
      console.log("run");
      return { ...response.data.data };
     } else {
      return course;
     }
    })
   );

   return { message: "You have succesfully updated a course" };
  } catch (error) {
   setLoading(false);
   return {
    message: "An error occured during the process, please try again later",
   };
  }
 };

 const deleteCourse = async (id) => {
  try {
   const response = await axios.delete(
    process.env.REACT_APP_BASEURL + "/api/v1/admin/delete-course/" + id,
    {
     withCredentials: true,
    }
   );
   setLoading(false);

   setCourses(courses.filter((elem) => elem._id !== response.data.id));

   return { message: "You have succesfully updated a course" };
  } catch (error) {
   setLoading(false);
   return {
    message: "An error occured during the process, please try again later",
   };
  }
 };

 return (
  <UserContext.Provider
   value={{
    toggleShowNav,
    toggleNavDisplay,
    user,
    setUser,
    token,
    setToken,
    admin,
    setAdmin,
    setLoading,
    loading,
    logOut,
    checkAuth,
    courses,
    getCourses,
    createCourse,
    deleteCourse,
    updateCourse,
   }}
  >
   {props.children}
  </UserContext.Provider>
 );
};
